export const List = [
  { title: "儲存資料", info: "網站將會儲存資料在您的設備" },
  { title: "快速分析", info: "視覺化的圖表，讓您可以直接看圖說故事" },
  { title: "持續追蹤", info: "固定使用所累積的資料，有利於您追蹤資料" },
];
